import { render } from "./AppWrapper.vue?vue&type=template&id=147b9186"
const script = {}

import exportComponent from "/home/runner/work/momentum-generator/momentum-generator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__